import { TCSystemAction, TSEvent } from './TCSystemModel'

export const setPhoneCalls = (payload: TSEvent[]): TCSystemAction => {
  return { type: 'SET_PHONECALLS', phoneCalls: payload }
}

export const setDND = (payload: boolean): TCSystemAction => {
  return { type: 'SET_DND', dnd: payload }
}
